import type { RangedFieldTypesMappings } from '@dynatrace-sdk/client-query';

/**
 * Checks whether the current record is of the timeseries format.
 * @param mappings - Field type mappings
 * @public
 */
export function checkTimeseriesFormat(mappings: RangedFieldTypesMappings):
  | {
      isTimeseries: false;
    }
  | {
      isTimeseries: true;
      timeframeField: string;
      durationField: string;
      arrayFields: string[];
    } {
  const timeframeFields: string[] = [];
  const durationFields: string[] = [];
  const arrayFields: string[] = [];

  for (const [key, mapping] of Object.entries(mappings)) {
    if (!mapping) {
      continue;
    }

    if (mapping.type === 'timeframe') {
      timeframeFields.push(key);
    } else if (mapping.type === 'duration') {
      durationFields.push(key);
    } else if (mapping.type === 'array') {
      // Timeseries arrays are either of type double or undefined
      if (mapping.types) {
        const isDoubleOrUndefined = mapping.types.every((mapType) => {
          const elementType = mapType.mappings?.element?.type;
          return (
            elementType === 'double' ||
            elementType === 'long' ||
            elementType === 'undefined'
          );
        });
        if (isDoubleOrUndefined) {
          arrayFields.push(key);
        }
      }
    }
  }

  const isTimeseries =
    timeframeFields.length === 1 &&
    durationFields.length === 1 &&
    arrayFields.length > 0;

  return isTimeseries
    ? {
        isTimeseries,
        timeframeField: timeframeFields[0],
        durationField: durationFields[0],
        arrayFields: arrayFields,
      }
    : { isTimeseries };
}
